/**
 * Per-card Swiper: swipe + autoplay.
 * Nested so it can live inside the featured-items carousel.
 */
if (!customElements.get('gltheaa-card-slideshow')) {
  class GltheaaCardSlideshow extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.onLoad = this.init.bind(this);
    }

    connectedCallback() {
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', this.onLoad, { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.onLoad);
      this.destroy();
    }

    init() {
      if (typeof Swiper === 'undefined' || this.swiper) return;

      const swiperElement = this.querySelector('.swiper');
      const slideCount = this.querySelectorAll('.swiper-slide').length;
      if (!swiperElement || slideCount < 2) return;

      const delay = Number(this.dataset.interval) || 4000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const config = {
        nested: true,
        slidesPerView: 1,
        speed: 500,
        rewind: true,
        watchOverflow: true,
        resistanceRatio: 0.65,
        preventClicks: true,
        preventClicksPropagation: true,
      };

      if (!reduceMotion) {
        config.autoplay = {
          delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.swiper = new Swiper(swiperElement, config);
    }

    destroy() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define('gltheaa-card-slideshow', GltheaaCardSlideshow);
}
